<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer">
    <div
      class="d-flex align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">
          {{ $t('general.all_right_reserved') }} &nbsp;&copy;&nbsp; 2020
        </span>
      </div>
      <div class="nav nav-dark">
        <a
          href="https://www.limonist.com"
          target="_blank"
          class="nav-link pr-3 pl-0"
        >
          <img width="100" src="https://www.limonist.com/img/theme-1/logo-act.png" alt="Limonist">
        </a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
